import { render, staticRenderFns } from "./SideNavDeliveryShao.vue?vue&type=template&id=75673832"
import script from "./SideNavDeliveryShao.vue?vue&type=script&lang=js"
export * from "./SideNavDeliveryShao.vue?vue&type=script&lang=js"
import style0 from "./SideNavDeliveryShao.vue?vue&type=style&index=0&id=75673832&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports